export default __webpack_public_path__ + "static/media/boost.4146faac.png";